(() => {
  const VERSION = '1.0.2';
  if (window.PBWCBProcessRefinementsV1?.version === VERSION) return;

  const norm = value => String(value || '').toLowerCase().replace(/×/g, 'x').replace(/[–—]/g, '-').replace(/\s+/g, ' ').trim();
  const routeFor = value => {
    const v = norm(value);
    if (v.includes('blank') || v.startsWith('no')) return 'blank';
    if (v.includes('pre-made') || v.includes('premade') || v.includes('template')) return 'template';
    if (v.includes('send your design') || v.includes('upload') || v.includes('own artwork')) return 'upload';
    return 'unknown';
  };
  const labelFor = value => {
    const route = routeFor(value);
    if (route === 'blank') return 'Blank Box';
    if (route === 'template') return 'Pre-Made Design';
    if (route === 'upload') return 'Upload Your Design';
    return value || 'Not selected';
  };
  const setText = (element, value) => {
    if (element && element.textContent !== value) element.textContent = value;
  };
  const show = (element, visible) => {
    if (element) element.hidden = !visible;
  };

  const init = context => {
    const root = context?.root;
    const state = context?.state;
    if (!root || !state || root.dataset.pbWcbProcessRefinements === VERSION) return null;

    const summary = root.querySelector('[data-pb-wcb-selected-summary]');
    if (!summary) return null;
    root.dataset.pbWcbProcessRefinements = VERSION;

    let checklist = summary.querySelector('[data-pb-wcb-refinement-checklist]');
    if (!checklist) {
      checklist = document.createElement('div');
      checklist.className = 'pb-wcb-v2__summary';
      checklist.dataset.pbWcbRefinementChecklist = '';
      checklist.innerHTML = `
        <div class="pb-wcb-v2__summary-heading">
          <span>Your selected box</span>
          <strong data-pb-wcb-v2-heading>Complete the remaining selections</strong>
        </div>
        <div class="pb-wcb-v2__summary-list">
          <div class="pb-wcb-v2__summary-row" data-pb-wcb-v2-row="size">
            <span class="pb-wcb-v2__summary-label">Size</span>
            <span class="pb-wcb-v2__summary-value" data-pb-wcb-v2-value="size">Not selected</span>
            <button type="button" data-pb-wcb-change="size">Choose</button>
          </div>
          <div class="pb-wcb-v2__summary-row" data-pb-wcb-v2-row="color">
            <span class="pb-wcb-v2__summary-label">Linen</span>
            <span class="pb-wcb-v2__summary-value" data-pb-wcb-v2-value="color">Not selected</span>
            <button type="button" data-pb-wcb-change="color">Choose</button>
          </div>
          <div class="pb-wcb-v2__summary-row" data-pb-wcb-v2-row="personalization">
            <span class="pb-wcb-v2__summary-label">Finish</span>
            <span class="pb-wcb-v2__summary-value" data-pb-wcb-v2-value="personalization">Not selected</span>
            <button type="button" data-pb-wcb-change="personalization">Choose</button>
          </div>
          <div class="pb-wcb-v2__summary-row" data-pb-wcb-v2-row="design" hidden>
            <span class="pb-wcb-v2__summary-label">Design</span>
            <span class="pb-wcb-v2__summary-value" data-pb-wcb-v2-value="design">Not selected</span>
            <button type="button" data-pb-wcb-refine-jump="design">Choose</button>
          </div>
          <div class="pb-wcb-v2__summary-row" data-pb-wcb-v2-row="details" hidden>
            <span class="pb-wcb-v2__summary-label">Details</span>
            <span class="pb-wcb-v2__summary-value" data-pb-wcb-v2-value="details">Not added</span>
            <button type="button" data-pb-wcb-refine-jump="details">Add</button>
          </div>
          <div class="pb-wcb-v2__summary-row" data-pb-wcb-v2-row="artwork" hidden>
            <span class="pb-wcb-v2__summary-label">Artwork</span>
            <span class="pb-wcb-v2__summary-value" data-pb-wcb-v2-value="artwork">Not attached</span>
            <button type="button" data-pb-wcb-refine-jump="artwork">Attach</button>
          </div>
          <div class="pb-wcb-v2__summary-row" data-pb-wcb-v2-row="vinyl" hidden>
            <span class="pb-wcb-v2__summary-label">Design color</span>
            <span class="pb-wcb-v2__summary-value" data-pb-wcb-v2-value="vinyl">Not selected</span>
            <button type="button" data-pb-wcb-refine-jump="vinyl">Choose</button>
          </div>
        </div>`;
      summary.append(checklist);
    }

    const row = name => checklist.querySelector(`[data-pb-wcb-v2-row="${name}"]`);
    const value = name => checklist.querySelector(`[data-pb-wcb-v2-value="${name}"]`);
    const heading = checklist.querySelector('[data-pb-wcb-v2-heading]');
    const sizeSection = root.querySelector('[data-pb-wedding-size-section]');
    const colorSection = root.querySelector('[data-pb-wcb-color-section]');
    const personalizationSection = root.querySelector('[data-pb-wedding-personalization-section]');
    const templateSection = root.querySelector('[data-pb-wedding-template-section]');
    const uploadSection = root.querySelector('[data-pb-wedding-upload-section]');
    const details = root.querySelector('[data-pb-personalization-details]');
    const artwork = root.querySelector('[data-pb-artwork-file]');
    const vinylSection = root.querySelector('[data-pb-wedding-vinyl-section]');
    const rushSection = root.querySelector('[data-pb-rush-section]');
    const rushCheckbox = rushSection?.querySelector('[data-pb-rush-checkbox]');
    const designGrid = root.querySelector('[data-pb-design-grid]');
    const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

    const setRow = (name, text, complete, visible = true, completeButton = 'Change', missingButton = 'Choose') => {
      const item = row(name);
      if (!item) return;
      show(item, visible);
      if (!visible) return;
      item.classList.toggle('is-missing', !complete);
      item.classList.toggle('is-complete', complete);
      setText(value(name), text);
      const button = item.querySelector('button');
      setText(button, complete ? completeButton : missingButton);
    };

    const update = () => {
      /* On mobile, Linen is deliberately available from first load. The V1 state
         still records whether the shopper has actively confirmed a color. */
      if (isMobile() && colorSection) colorSection.hidden = false;

      const selected = typeof context.read === 'function' ? context.read() : {};
      const route = state.pers ? routeFor(selected.pers) : 'none';
      const designButton = root.querySelector('[data-pb-design-button].is-active');
      const vinylButton = root.querySelector('[data-pb-vinyl-button].is-active');
      const chosenDesign = designButton?.dataset.pbDesignNumber || '';
      const chosenVinyl = vinylButton?.dataset.pbVinylName || '';
      const hasDetails = Boolean(String(details?.value || '').trim());
      const attachedFile = artwork?.files?.[0] || null;

      const sizeDone = Boolean(state.size);
      const colorDone = Boolean(state.color);
      const personalizationDone = Boolean(state.pers);
      const designDone = Boolean(chosenDesign);
      const vinylDone = Boolean(chosenVinyl);
      const artworkDone = Boolean(attachedFile);

      setRow('size', sizeDone ? (selected.size || 'Selected') : 'Not selected', sizeDone);
      setRow('color', colorDone ? (selected.color || 'Selected') : 'Not selected', colorDone);
      setRow('personalization', personalizationDone ? labelFor(selected.pers) : 'Not selected', personalizationDone);

      const template = route === 'template';
      const upload = route === 'upload';
      setRow('design', designDone ? `Design ${chosenDesign}` : 'Not selected', designDone, template);
      setRow('details', hasDetails ? 'Added' : 'Not added', hasDetails, template, 'Change', 'Add');
      setRow('artwork', artworkDone ? attachedFile.name : 'Not attached', artworkDone, upload, 'Change', 'Attach');
      setRow('vinyl', vinylDone ? chosenVinyl : 'Not selected', vinylDone, template || upload);

      const required = [sizeDone, colorDone, personalizationDone];
      if (template) required.push(designDone, hasDetails, vinylDone);
      if (upload) required.push(artworkDone, vinylDone);
      const missing = required.filter(done => !done).length;
      checklist.classList.toggle('pb-wcb-v2__summary-ready', missing === 0);
      setText(heading, missing === 0 ? 'Ready to add to cart' : `${missing} selection${missing === 1 ? '' : 's'} still needed`);

      /* V1 historically hides this section until its three core choices are complete.
         This refinement deliberately turns it into a persistent completion checklist. */
      summary.hidden = false;
      summary.removeAttribute('aria-hidden');
    };

    const jump = target => {
      let element = null;
      if (target === 'size') element = sizeSection;
      if (target === 'color') element = colorSection;
      if (target === 'personalization') element = personalizationSection;
      if (target === 'design') element = designGrid || templateSection;
      if (target === 'details') element = details?.closest('.pb-wedding-inline__field') || details || templateSection;
      if (target === 'artwork') element = artwork?.closest('.pb-wedding-inline__upload-box') || artwork || uploadSection;
      if (target === 'vinyl') element = vinylSection;
      if (target === 'rush') element = rushSection || summary;
      if (target === 'summary') element = summary;
      element?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (target === 'details') setTimeout(() => details?.focus({ preventScroll: true }), 350);
    };

    checklist.addEventListener('click', event => {
      const button = event.target.closest('[data-pb-wcb-refine-jump]');
      if (!button) return;
      event.preventDefault();
      jump(button.dataset.pbWcbRefineJump);
    });

    let timers = [];
    const schedule = () => {
      timers.forEach(clearTimeout);
      timers = [0, 80, 220, 480].map(delay => setTimeout(update, delay));
    };

    let scrollTimer = 0;
    const queueJump = (target, delay = 280) => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        update();
        requestAnimationFrame(() => jump(target));
      }, delay);
    };

    root.addEventListener('click', schedule, true);
    root.addEventListener('change', schedule, true);
    root.addEventListener('input', schedule, true);
    document.addEventListener('variant:change', schedule);
    window.addEventListener('pageshow', schedule);
    window.addEventListener('popstate', schedule);

    window.addEventListener('pb:wcb:size_selected', () => {
      schedule();
      queueJump(state.color ? 'personalization' : 'color');
    });
    window.addEventListener('pb:wcb:color_selected', () => {
      schedule();
      queueJump('personalization');
    });
    window.addEventListener('pb:wcb:personalization_path_selected', event => {
      schedule();
      const route = event?.detail?.path || routeFor(event?.detail?.selectedValue || context.read?.().pers || '');
      if (route === 'template') queueJump('design');
      else if (route === 'upload') queueJump('artwork');
      else if (route === 'blank') queueJump('rush');
    });
    window.addEventListener('pb:wcb:design_selected', () => {
      schedule();
      queueJump('details');
    });
    window.addEventListener('pb:wcb:finish_selected', () => {
      schedule();
      queueJump('rush');
    });

    const advanceFromDetails = () => {
      if (String(details?.value || '').trim()) queueJump('vinyl', 220);
    };
    details?.addEventListener('change', advanceFromDetails);
    details?.addEventListener('blur', advanceFromDetails);
    artwork?.addEventListener('change', () => {
      if (artwork?.files?.length) queueJump('vinyl', 240);
    });
    rushCheckbox?.addEventListener('change', () => queueJump('summary', 180));

    schedule();
    return { root, update, schedule, jump, queueJump };
  };

  let bootAttempts = 0;
  const boot = () => {
    const contexts = window.PBWCBMobileConversionV1?.contexts || [];
    if (!contexts.length) {
      bootAttempts += 1;
      if (bootAttempts < 100) {
        setTimeout(boot, 60);
      } else {
        window.PBWCBProcessRefinementsV1 = { version: VERSION, active: false, contexts: [] };
      }
      return;
    }
    const refinements = contexts.map(init).filter(Boolean);
    window.PBWCBProcessRefinementsV1 = { version: VERSION, active: Boolean(refinements.length), contexts: refinements };
  };

  boot();
})();
